/**
 * Maps a Case Copy / Case Diff environment name (e.g. 'dev', 'stable',
 * 'staging', 'app') and a service ('cases' or 'users') to the base URL of that
 * service's API.
 *
 * By default every env/service resolves to `https://<env>.vrpatients.com` — in
 * production the cases and users APIs share a host and differ only by path.
 * Add entries to `envOverrides` to point a specific env somewhere else when
 * running locally — for example, to make "Stable" talk to services running on
 * your machine. Locally the cases and users services usually live on different
 * ports, so an override can be either:
 *
 *   - a string, applied to every service, or
 *   - an object keyed by service name: { cases, users }
 *
 * Example: 
 *   
 *   stable: {
 *     cases: 'http://localhost:4001',
 *     users: 'http://localhost:4000',
 *   }
 * 
 * These overrides are only meant for local development; leave `envOverrides`
 * empty when committing.
 */
const envOverrides = {};

export default function envBaseUrl(env, service = 'cases') {
  const override = envOverrides[env];
  const base = override
    ? (typeof override === 'string' ? override : override[service])
    : `https://${env}.vrpatients.com`;
  // Tolerate trailing slashes in overrides so callers can safely append paths.
  return base.replace(/\/+$/, '');
}
